import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-bg-deep/80 border-b border-border-primary/50"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img src="/images/logo-white.svg" alt="Dough" className="h-8" />
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          <a href="#features" className="text-text-secondary hover:text-white transition-colors text-sm font-medium">
            Features
          </a>
          <a href="#how-it-works" className="text-text-secondary hover:text-white transition-colors text-sm font-medium">
            How It Works
          </a>
          <a href="#screenshots" className="text-text-secondary hover:text-white transition-colors text-sm font-medium">
            Screenshots
          </a>
          <a
            href="/download"
            className="bg-brand-teal hover:bg-brand-teal/90 text-white font-semibold text-sm px-5 py-2.5 rounded-xl transition-colors"
          >
            Download
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-white p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {mobileOpen ? (
              <path d="M6 6l12 12M6 18L18 6" />
            ) : (
              <path d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden backdrop-blur-xl bg-bg-deep/95 border-t border-border-primary/50 px-4 pb-4">
          <a
            href="#features"
            className="block py-3 text-text-secondary hover:text-white transition-colors text-sm font-medium"
            onClick={() => setMobileOpen(false)}
          >
            Features
          </a>
          <a
            href="#how-it-works"
            className="block py-3 text-text-secondary hover:text-white transition-colors text-sm font-medium"
            onClick={() => setMobileOpen(false)}
          >
            How It Works
          </a>
          <a
            href="#screenshots"
            className="block py-3 text-text-secondary hover:text-white transition-colors text-sm font-medium"
            onClick={() => setMobileOpen(false)}
          >
            Screenshots
          </a>
          <a
            href="/download"
            className="block mt-2 text-center bg-brand-teal hover:bg-brand-teal/90 text-white font-semibold text-sm px-5 py-2.5 rounded-xl transition-colors"
            onClick={() => setMobileOpen(false)}
          >
            Download
          </a>
        </div>
      )}
    </nav>
  );
}
